import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SnackBarComponent } from './components/snack-bar/snack-bar.component';
import { LoaderComponent } from './components/loader/loader.component';
import { CustomersTableComponent } from './components/customers-table/customers-table.component';
import { ShellComponent } from './components/shell/shell.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { TransformTitlePipe } from './pipes/transform-title.pipe';
import { PreviewTableComponent } from './components/preview-table/preview-table.component'
import { UsersListDialogComponent } from './components/users-list-dialog/users-list-dialog.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { CustomMultiSelectComponent } from './components/custom-multi-select/custom-multi-select.component';
import { RemoveDoubleUnderscore } from './pipes/remove-double-underscore.pipe';
import { PageLoaderComponent } from './components/page-loader/page-loader.component';
import { SentenceCasePipe } from './pipes/sentence-case.pipe';
import { ColorPickerComponent } from './components/color-picker/color-picker.component';
import { SideModalComponent } from './components/side-modal/side-modal.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { UTCtoLocalDatePipe } from './pipes/UTC-to-local.pipe';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NotificationCenterComponent } from './components/notification-center/notification-center.component';
import { ManageColumnsDialogComponent } from './components/manage-columns-dialog/manage-columns-dialog.component';
import { YouTubePreviewDirective } from './components/media-preview/youtube-preview.directive';
import { ImagePreviewDirective } from './components/media-preview/image-preview.directive';
import { MediaPreviewComponent } from './components/media-preview/media-preview.component';
import { YouTubePlayerComponent } from './components/media-preview/youtube-player/youtube-player.component';

@NgModule({
    declarations: [HeaderComponent, SnackBarComponent, LoaderComponent, PageLoaderComponent, CustomersTableComponent, ShellComponent, ProgressBarComponent, TransformTitlePipe, PreviewTableComponent, UsersListDialogComponent, RemoveDoubleUnderscore, CustomMultiSelectComponent, SentenceCasePipe, ColorPickerComponent, SideModalComponent, UTCtoLocalDatePipe, NotificationCenterComponent, ManageColumnsDialogComponent, YouTubePreviewDirective, ImagePreviewDirective, MediaPreviewComponent, YouTubePlayerComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    imports: [
        CommonModule,
        MatToolbarModule,
        MatIconModule,
        MatPaginatorModule,
        MatSortModule,
        MatTableModule,
        MatButtonModule,
        MatStepperModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatListModule,
        MatDialogModule,
        MatSidenavModule,
        MatToolbarModule,
        MatTabsModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        MatCardModule,
        MatListModule,
        MatRadioModule,
        MatSnackBarModule,
        MatOptionModule,
        MatAutocompleteModule,
        MatCheckboxModule,
        MatProgressBarModule,
        NgxMatSelectSearchModule,
        MatSlideToggleModule,
        MatDatepickerModule,
        FlexLayoutModule,
        MatBadgeModule
    ],
    exports: [HeaderComponent, LoaderComponent, PageLoaderComponent, ShellComponent, ProgressBarComponent, TransformTitlePipe, CustomersTableComponent, CustomMultiSelectComponent, PreviewTableComponent, RemoveDoubleUnderscore, SentenceCasePipe, ColorPickerComponent, SideModalComponent, UTCtoLocalDatePipe, YouTubePreviewDirective, ImagePreviewDirective, YouTubePlayerComponent]
})
export class SharedModule { }
